import React, { useEffect, useState } from "react";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";

function InvoiceControl() {
  const [loading, setLoading] = useState(false);
  const { checkNetwork } = useNetwork();

  const showAlert = useShowAlert();

  const toggleItems = [
    {
      key: "invoice",
      label: "Customer Add",
      icon: "ng ng-ng-customers-add-icon",
      color: "text-success",
      subtext:
        "Enable this option to allow adding Customer Details.",
    },
  ];
  const initialToggleState = toggleItems.reduce((acc, item) => {
    acc[item.key] = false;
    return acc;
  }, {});

  const [toggles, setToggles] = useState(initialToggleState);
  const handleUpdate = async (value, key) => {
    setLoading((prev) => ({ ...prev, [key]: true }));

    try {
      if (!checkNetwork()) return;
      var data = {
        iscustomer: value,
      };
      const response = await AxiosInstance.post(`module/settings/invoice`, data);
      showAlert("success", response.data.message);
      setToggles((prev) => ({ ...prev, [key]: !prev[key] }));
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  };

  const handlelist = async () => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/settings`);
      const invoice = response.data?.results?.invoice_settings;

      setToggles((prevToggles) => ({
        ...prevToggles,
        invoice: invoice?.isCustomer,
      }));
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handleSwitchChange = (event, key) => {
    const newValue = event.target.checked;
    handleUpdate(newValue, key);
  };

  useEffect(() => {
    handlelist();
  }, []);
  return (
    <>
      <div className="row">
        <div className="col-lg-5">
          <div className="card">
            <div className="card-header p-3 bg-light-core">
              <h6 className="mb-0 text-dark">Invoice Settings</h6>
            </div>
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-lg-12">
                  <div className="row align-items-center">
                    {" "}
                    <div className="col-lg-12">
                      {toggleItems.map(
                        ({ key, label, icon, color, subtext }) => (
                          <React.Fragment key={key}>
                            <div className="d-flex align-items-center">
                              <div className="d-flex">
                                <i className={`${icon} ${color} font-30`}></i>
                              </div>
                              <div class="flex-grow-1 d-flex align-items-center justify-content-between">
                                <div class="mb-sm-0 mb-2 ms-2">
                                  <label className=" mb-0 ">
                                    {label}
                                    {/* <small className="text-muted">
                                    {subtext}
                                  </small> */}
                                    <span className="tooltip-container ms-1">
                                      <span className="tooltip-icon">ℹ</span>
                                      <span
                                        className="tooltip-text"
                                        style={{ zIndex: 10 }}
                                      >
                                        {subtext}
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div className="ms-auto custom-toggle-wrapper">
                                <label className="custom-toggle">
                                  <input
                                    type="checkbox"
                                    id={`${key}Toggle`}
                                    checked={toggles[key]}
                                    onChange={(event) =>
                                      handleSwitchChange(event, key)
                                    }
                                    disabled={loading[key]}
                                  />
                                  <span className="slider">
                                    {loading[key] ? (
                                      <span
                                        className={`spinner-inside ${
                                          toggles[key] ? "spinner-right" : ""
                                        }`}
                                      />
                                    ) : (
                                      <>
                                        {toggles[key] && (
                                          <span className="label-on ms-0-1">
                                            ON
                                          </span>
                                        )}
                                        {!toggles[key] && (
                                          <span className="label-off ms-3">
                                            OFF
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </span>
                                </label>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      )}
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default InvoiceControl;
